export default {"src":"/_next/static/media/axis.8a8e40e1.svg","height":238,"width":228,"blurWidth":0,"blurHeight":0};